// @ts-nocheck
import type * as Types from '../../../../../types/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CommunityQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
  page: Types.CommunityListPageInput;
  fundraiserId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type CommunityQuery = { __typename?: 'Query', community: { __typename?: 'CommunityList', posts: Array<{ __typename?: 'Post', id: string, created: number, amount: number, donation: number, recurrenceInterval: Types.DonationRecurrenceInterval, comment?: string | null, anonymous: boolean, author?: { __typename?: 'PostAuthor', name: string, profilePictureUrl?: string | null } | null, reply?: { __typename?: 'PostReply', created: number, text: string, author: { __typename?: 'PostAuthor', name: string, profilePictureUrl?: string | null } } | null, dedication?: { __typename?: 'Dedication', type: Types.DedicationType, firstName: string, lastName: string } | null, fundraiser?: { __typename?: 'Fundraiser', id: string, name: string } | null }>, pageInfo: { __typename?: 'CommunityListPageInfo', page: number, pageSize: number, totalPages: number, totalItems: number } } };


export const CommunityDocument = /*#__PURE__*/ gql`
    query Community($slug: String!, $page: CommunityListPageInput!, $fundraiserId: ID) {
  community(pageSlug: $slug, page: $page, fundraiserId: $fundraiserId) {
    posts {
      id
      created
      amount
      donation
      recurrenceInterval
      comment
      anonymous
      author {
        name
        profilePictureUrl
      }
      reply {
        created
        text
        author {
          name
          profilePictureUrl
        }
      }
      dedication {
        type
        firstName
        lastName
      }
      fundraiser {
        id
        name
      }
    }
    pageInfo {
      page
      pageSize
      totalPages
      totalItems
    }
  }
}
    `;

/**
 * __useCommunityQuery__
 *
 * To run a query within a React component, call `useCommunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      page: // value for 'page'
 *      fundraiserId: // value for 'fundraiserId'
 *   },
 * });
 */
export function useCommunityQuery(baseOptions: Apollo.QueryHookOptions<CommunityQuery, CommunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityQuery, CommunityQueryVariables>(CommunityDocument, options);
      }
export function useCommunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityQuery, CommunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityQuery, CommunityQueryVariables>(CommunityDocument, options);
        }
export function useCommunitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommunityQuery, CommunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunityQuery, CommunityQueryVariables>(CommunityDocument, options);
        }
export type CommunityQueryHookResult = ReturnType<typeof useCommunityQuery>;
export type CommunityLazyQueryHookResult = ReturnType<typeof useCommunityLazyQuery>;
export type CommunitySuspenseQueryHookResult = ReturnType<typeof useCommunitySuspenseQuery>;
export function refetchCommunityQuery(variables: CommunityQueryVariables) {
      return { query: CommunityDocument, variables: variables }
    }